"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_1 = require("mobx");

var mobx_react_1 = require("mobx-react");

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var shared_1 = require("../../../shared");

var Button_1 = require("../Button/Button");

var ToastType_1 = require("../../portal/Toast/models/ToastType");

var Toaster_1 = __importDefault(require("../../portal/Toaster"));

var CopyButton_meta_1 = require("./CopyButton.meta");

var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];

var CopyButton =
/** @class */
function (_super) {
  __extends(CopyButton, _super);

  function CopyButton(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = CopyButton_meta_1.COPY_URL_CATEGORY_KEY;
    _this.componentKey = CopyButton_meta_1.COPY_URL_COMPONENT_KEY;
    _this.toasterProps = {
      items: []
    };

    _this.handleClick = function (event, payload) {
      return __awaiter(_this, void 0, void 0, function () {
        var onClick, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              onClick = this.props.onClick;
              if (!payload) return [3
              /*break*/
              , 5];
              _a.label = 1;

            case 1:
              _a.trys.push([1, 3,, 4]);

              event.stopPropagation();
              return [4
              /*yield*/
              , navigator.clipboard.writeText(payload)];

            case 2:
              _a.sent();

              if (onClick) {
                onClick(event, payload);
              }

              if (!this.hideToaster) {
                this.toasterProps = {
                  items: [__assign({
                    toastId: ksys_app_template_1.utils.guid.generateGuid(),
                    text: "Copied the following URL to clipboard: " + payload,
                    type: ToastType_1.ToastType.success,
                    canClose: false,
                    displaySeconds: 5
                  }, this.successToastProps)]
                };
              }

              return [3
              /*break*/
              , 4];

            case 3:
              e_1 = _a.sent();
              console.error("Failed to copy " + payload + " into user clipboard");

              if (!this.hideToaster) {
                this.toasterProps = {
                  items: [__assign({
                    toastId: ksys_app_template_1.utils.guid.generateGuid(),
                    text: "Failed to copy the URL to clipboard",
                    type: ToastType_1.ToastType.error,
                    canClose: true
                  }, this.failureToastProps)]
                };
              }

              return [3
              /*break*/
              , 4];

            case 4:
              return [3
              /*break*/
              , 6];

            case 5:
              if (!this.hideToaster) {
                this.toasterProps = {
                  items: [__assign({
                    toastId: ksys_app_template_1.utils.guid.generateGuid(),
                    text: "Failed to copy the URL to clipboard",
                    type: ToastType_1.ToastType.error,
                    canClose: true
                  }, this.failureToastProps)]
                };
              }

              _a.label = 6;

            case 6:
              return [2
              /*return*/
              ];
          }
        });
      });
    };
    /**
     * stop execution of parent event handlers but allow the button to execute the default behaviour of firing the click event on key press.
     * This is needed in the scenario where the DocumentDownload has wrapping on click event to handle downloads when the label or download icon is clicked.
     */


    _this.handleOnKeyDown = function (e) {
      if (ACCEPT_KEYS.indexOf(e.key) >= 0) {
        e.stopPropagation();
      }
    };

    return _this;
  }

  Object.defineProperty(CopyButton.prototype, "hideToaster", {
    get: function get() {
      return this.props.toastProps && this.props.toastProps.hide;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CopyButton.prototype, "successToastProps", {
    get: function get() {
      return this.props.toastProps && this.props.toastProps.successToast || {};
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CopyButton.prototype, "failureToastProps", {
    get: function get() {
      return this.props.toastProps && this.props.toastProps.failureToast || {};
    },
    enumerable: true,
    configurable: true
  });

  CopyButton.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        toastProps = _a.toastProps,
        buttonProps = __rest(_a, ["className", "toastProps"]);

    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Button_1.Button, __assign({
      className: className
    }, buttonProps, {
      onClick: this.handleClick,
      onKeyDown: this.handleOnKeyDown
    })), react_1.default.createElement(Toaster_1.default, __assign({}, this.toasterProps)));
  };

  __decorate([mobx_1.observable.ref], CopyButton.prototype, "toasterProps", void 0);

  __decorate([mobx_1.computed], CopyButton.prototype, "hideToaster", null);

  __decorate([mobx_1.computed], CopyButton.prototype, "successToastProps", null);

  __decorate([mobx_1.computed], CopyButton.prototype, "failureToastProps", null);

  CopyButton = __decorate([mobx_react_1.observer], CopyButton);
  return CopyButton;
}(shared_1.ComponentBase);

exports.CopyButton = CopyButton;
exports.default = shared_1.InjectedStyledComponent(CopyButton, CopyButton_meta_1.COPY_URL_CATEGORY_KEY, CopyButton_meta_1.COPY_URL_COMPONENT_KEY);